module.exports = __webpack_public_path__ + "files/f4fb236dc365a738a2490411e24a43b0.png";